/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

import SvgIcon from "@mui/material/SvgIcon";

const Enclosed = (props) => (
  <SvgIcon
    {...props}
    x="0px"
    y="0px"
    viewBox="0 0 100 90.855"
    enableBackground="new 0 0 100 90.855"
  >
    <polygon points="10.026,90.855 100,90.855 100,81.492 19.378,81.492 19.378,46.116 100,9.689 100,0 0,45.165 0,54.854 	10.026,50.372 " />
  </SvgIcon>
);
export default Enclosed;
